import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0be9ae8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "aria-hidden": "true" }
const _hoisted_2 = { class: "delivery-option mb-x2" }
const _hoisted_3 = { class: "flex mt-8" }
const _hoisted_4 = { class: "ml-30 mt-18" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 mt-x3 gap-x6" }
const _hoisted_6 = {
  key: 0,
  class: "delivery-option"
}
const _hoisted_7 = { class: "flex my-8" }

import CheckoutSkeletonLine from '@/b2c/shared/checkout/ui/CheckoutSkeletonLine.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutCustomerDeliverableSkeleton',
  props: {
    pickupDisabled: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_InputRadio = _resolveComponent("InputRadio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_InputRadio, {
          name: "skeleton-dummy",
          disabled: true,
          label: "",
          class: "opacity-25"
        }),
        _createVNode(CheckoutSkeletonLine, { class: "-my-8" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CheckoutSkeletonLine, { class: "sm:w-100" }),
        _createVNode(CheckoutSkeletonLine, { class: "mt-15 mb-25 h-90" }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createVNode(CheckoutSkeletonLine, { class: "mb-8" }),
            _createVNode(CheckoutSkeletonLine, { class: "mb-8" }),
            _createVNode(CheckoutSkeletonLine, { class: "mb-8" }),
            _createVNode(CheckoutSkeletonLine, { class: "mb-25" }),
            _createVNode(CheckoutSkeletonLine, { class: "mb-8 h-35 sm:w-150" })
          ]),
          _createElementVNode("div", null, [
            _createVNode(CheckoutSkeletonLine)
          ])
        ]),
        _createVNode(CheckoutSkeletonLine, { class: "mb-15 mt-40 sm:w-1/2" }),
        _createVNode(CheckoutSkeletonLine, { class: "mb-15 sm:w-1/2" }),
        _createVNode(CheckoutSkeletonLine, { class: "mb-15 sm:w-1/2" })
      ])
    ]),
    (!__props.pickupDisabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_InputRadio, {
              name: "skeleton-dummy",
              disabled: true,
              label: "",
              class: "opacity-25"
            }),
            _createVNode(CheckoutSkeletonLine, { class: "-my-8" })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})